/* global gsap, ScrollTrigger, VideoCarousel, _, xcopriGetVars, YT, siteMeta */
(function app($, utils, doc) {
    const { prescriptions, patients } = siteMeta;
    const { waitForGlobal, checkCookie, toggleDropdown, qsa, qs } = utils;
    const dataLayer = window.dataLayer || [];

    gsap.defaults({ duration: 1.5, ease: 'easeOut' });
    ScrollTrigger.defaults({
        toggleActions: 'play complete complete complete',
        start:         'top center',
        once:          false,
        // markers:       { startColor: 'green', endColor: 'red', fontSize: '12px' },
    });
    const tl = {
        section: {},
    }; // timeline object.

    const youtubePlayers = {};

    /**
    *  Use the google api to track an event.
    * @param {string} category
    * @param {string} action
    * @param {string} label
    */
    function trackEvent(event, params = {}) {
        if (!event) return;
        // console.log('trackEvent', event, params);
        dataLayer.push({ event, ...params });
    }

    const app = {
        /**
         * Elements
         */
        $areYouHCP:            $('#areYouHCP'),
        $siteNav:              $('#site-navigation'),
        $mainMenu:             $('#main-menu'),
        $backToTop:            $('.back-to-top'),
        $progressRing:         $('.progress-ring'),
        $hashAnchors:          $('a[href*="#"]').not('[href="#"]').not('[href="#0"]'),
        $clearStorage:         $('#clear-storage'),
        $footer:               $('#colophon'),
        leaveModalBtnSelector: 'a.open-leave-modal, .open-leave-modal > a',
        $modals:               $('.modal'),
        $navBarToggler:        $('.navbar-toggler'),
        tray:                  qs('.isi.tray'),
        content:               qs('#content'),
        $closeISIBtn:          $('.toggle-isi.expanded').hide(),
        $downloadBtns:         $('.btn-download'),
        $arrowBtns:            $('.btn-arrow'),
        onISIOpenLocation:     0,
        $body:                 $(document.body),
        $youTubeVideos:        $('[data-youtube-id]'),

        /**
         * Check for cookie or local storage.
         * @returns {Boolean}
         */
        getAreYouHCP() {
            return checkCookie('areyouHCP') === 'true' || sessionStorage.getItem('areyouHCP') === 'yes';
        },

        leaveModalBtn(e) {
            e.preventDefault();
            const modalSelector = this.dataset.modal || e.target.dataset.modal || '#leave-modal';
            const $modal = $(modalSelector);
            const $leaveLink = $modal.find('.leave-link');
            const url = this.href || e.target.href || '#';
            $leaveLink
                .attr('href', url)
                .attr('rel', this.rel || e.target.rel || $leaveLink.attr('rel'))
                .attr('target', this.target || e.target.target || $leaveLink.attr('target'))
                .one('click', () => {
                    $modal.modal('hide');
                    trackEvent('link_click', { category: 'External Link', label: 'SKLS Interstitial: Leave', url });
                });
            $modal.modal('show');
        },

        openModalFromURL() {
            if (xcopriGetVars && xcopriGetVars.modal) {
                // $(`#${xcopriGetVars.modal}`).modal('show'); // Does not autoplay the video.
                $(`[data-target="#${xcopriGetVars.modal}"]`).trigger('click');
            }
        },

        /**
         * Btn click for Are You HCP.
         * @returns {null}
         */
        btnAreYouHCP() {
            const answer = this.textContent.toLowerCase();
            if (answer === 'yes') {
                // Set the cookie for a year
                doc.cookie = 'areyouHCP=true; Path=/; Max-Age=31536000';
                sessionStorage.setItem('areyouHCP', 'yes');
                app.$areYouHCP.modal('hide');
                return;
            }
            sessionStorage.setItem('areyouHCP', 'no');
            window.location.href = 'http://www.xcopri.com';
        },

        /**
         * Initiate on window load.
         */
        triggerAreYouHCP() {
            if (!app.getAreYouHCP()) {
                $('.btn-areYouHCP').one('click', app.btnAreYouHCP);
                app.$areYouHCP.modal('show');
            }
        },

        updateNumbers() {
            $('.prescriptions').each((i, el) => {
                el.textContent = el.classList.contains('no-approx') ? prescriptions.replace('~', '') : prescriptions;
            });

            $('.patients').each((i, el) => {
                el.textContent = el.classList.contains('no-approx') ? patients.replace('~', '') : patients;
            });
        },

        /**
         * Scroll to a specific section using hashes.
         * @param {String} hash hash value of the section
         * @param {int} delay delay in milliseconds.
         * @returns null
         */
        scrollTo(hash = null, delay = 0, duration = 0.75) {
            if (!hash)
                return false;

            hash = hash.split('?')[0];
            hash = qs(`${hash}_hash`) || qs(hash);

            if (!hash)
                return false;
            // Close the menu first.
            app.$mainMenu.collapse('hide');
            return setTimeout(() => {
                gsap.to(window, {
                    duration,
                    scrollTo: {
                        y:        `#${hash.id}`,
                        offsetY:  utils.globals.siteNavHeight,
                        ease:     'power2.inOut',
                        autoKill: false,
                    },
                });
            }, delay);
        },

        /**
         * Move to a specific section on the page by hash value.
         * @param {Event} e Event object.
         */
        moveToHash(e) {
            // target matches
            const duration = e.target.matches('.tray-arrow') ? 0 : 1;
            if (e.target.matches('.tray-arrow'))
                app.updateISITrey('open');

            if (this.hash && app.scrollTo(this.hash, 0, duration)) {
                e.preventDefault();
                if (this.hash !== '#isi-bottom' && this.hash !== '#content')
                    window.location.hash = this.hash;
            }
        },

        clearStorage(e) {
            e.preventDefault();
            sessionStorage.removeItem('areyouHCP');
            doc.cookie = 'areyouHCP=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            window.location.reload();
        },

        /**
         * Events that happen on window scroll.
         */
        onWindowScroll() {

        },

        /**
         * Set the initial value of some elements.
         */
        setElementsHeight() {
            app.$mainMenu.collapse('hide');
            utils.globals.siteNavHeight = app.$siteNav.outerHeight();
            utils.globals.trayHeight = gsap.getProperty(app.tray, 'height');
            // app.$backToTop.css('bottom', gsap.getProperty(app.tray, 'height'));
        },

        /**
         * Events that happen on window resize.
         */
        onWindowResize() {
            app.setElementsHeight();
            // app.safetyTable();
            // app.mobileCollapse();
            ScrollTrigger.refresh();
        },

        updateISITrey(state = 'open') {
            if (state === 'open') {
                app.onISIOpenLocation = window.pageYOffset || document.documentElement.scrollTop;
                app.$closeISIBtn.show();
            } else {
                app.onISIOpenLocation = 0;
                app.$closeISIBtn.hide();
            }
        },

        /**
         * These animations happen across the site.
         */
        globalAnimations() {
            // close button
            tl.closeISITween    = gsap.timeline();
            tl.downloadBtnTween = gsap.timeline();
            tl.arrowBtnTween    = gsap.timeline();
            // ISI Tray
            gsap.timeline({
                scrollTrigger: {
                    trigger:       '.isi.bottom',
                    start:         `${utils.globals.trayHeight} bottom`,
                    toggleActions: 'restart none none reverse',
                    once:          false,
                },
            }).to('.isi.tray', 0.2, {
                yPercent: 101,
                onStart() { app.$mainMenu.collapse('hide'); },
                onReverseComplete() {
                    app.updateISITrey('close');
                    $(window).trigger('isi-try-shown');
                },
                onComplete() {
                    // trigger window isi event
                    $(window).trigger('isi-try-hidden');
                },
            });

            // Back to top button animation and close button for ISI.
            gsap.timeline({
                scrollTrigger: { trigger:       '.page-header',
                    start:         'bottom top',
                    toggleActions: 'restart none none reverse',
                    once:          false },
            }).to('.back-to-top, .toggle-isi.expanded', 0.2, { opacity: 1, scale: 1, pointerEvents: 'auto' });

            // Burger Menu
            tl.hamburgerMenu = gsap.timeline({ paused: true });
            tl.hamburgerMenu.to('.menu-toggler line', {
                transformOrigin: 'center center',
                duration:        0.2,
                scale:           i => (i === 1 ? 0 : 1),
                attr:            {
                    y1: i => (i === 0 ? 28.288 : 11.712),
                    y2: i => (i === 2 ? 28.288 : 11.712),
                    x1: 11.712,
                    x2: 28.288,
                },
            }, 'start');
        },

        /**
         * Use the youtube API to create a player.
         * Creates a responsive container for the video using bootstrap classes.
         * @param {Element} el html element (div) that will hold the youtube player.
         * @param {String} id youtube video id.
         * @returns YouTube player object.
         */
        makeYouTubePlayer(el, id, action) {
            if (youtubePlayers[id]) {
                action === 'hidden' ? youtubePlayers[id].stopVideo() : youtubePlayers[id].playVideo();
                return;
            }

            // create a div to hold the player.
            const playerContainer  = document.createElement('div');
            playerContainer.classList.add('embed-responsive', 'embed-responsive-16by9');
            el.classList.add('embed-responsive-item');
            el.parentNode.insertBefore(playerContainer, el);
            playerContainer.appendChild(el);

            YT.ready(() => {
                youtubePlayers[id] = new YT.Player(el, {
                    videoId:    id,
                    playerVars: { autoplay: 1, controls: 1, showinfo: 0, autohide: 1, modestbranding: 1, rel: 0, iv_load_policy: 3 },
                    events:     {
                        onReady: () => youtubePlayers[id].playVideo(),
                    },
                });
            });
        },

        /**
         * Handles the opening and closing of modals.
         * Looks for an elements with a youtube-id attribute and starts the player.
         * @param {Event} e Event
         * @returns null
         */
        onModalsShowAndHidden(e) {
            // Find a find a div with a youtube video on it.
            const isYoutube = qs('[data-youtube-id]', this);

            // If one is found, start the player, the player will play when ready.
            // Stops the video if the modal is hidden.
            if (!isYoutube) return;

            waitForGlobal('YT', () => {
                app.makeYouTubePlayer(isYoutube, isYoutube.dataset.youtubeId, e.type);
            });
        },

        collapseOnShownHidden(e) {
            let toggler = null;
            // two types of collapse, mobile and faq.
            if (this.classList.contains('faq__answer'))
                toggler = $(this).closest('.faq__row').find('.faq__toggle path');
            else if (this.classList.contains('mobile-collapse'))
                toggler = $(`.${this.id}`).find('path');

            // Exit if no toggler found.
            if (!toggler)
                return;

            // Animate depending on the action.
            const action = e.type === 'shown';
            gsap.to(toggler, {
                duration:        0.5,
                rotate:          i => (action ? 90 * (i + 1) : 0),
                transformOrigin: 'center center',
                ease:            'back.inOut(1.7)',
            });
        },

        /**
         * Epilepsy page animations.
         */
        epilepsyFacts() {
            // timelines
            tl.section.one   = gsap.timeline({ scrollTrigger: '#trigger_animation_one' }).addLabel('start');
            tl.section.two   = gsap.timeline({ scrollTrigger: '#trigger_animation_two' }).addLabel('start');
            tl.section.three = gsap.timeline({ scrollTrigger: '#impact-of-epilepsy_hash' }).addLabel('start'); // Bubbles

            // Initiate time lines, one per section that animates.
            tl.section.one.to('.card', {
                duration: 1,
                y:        0,
                scale:    1,
                stagger:  {
                    grid:   [1, 3],
                    from:   'start',
                    amount: 0.5,
                },
            }, 'start');

            // People Section
            tl.section.two.fromTo('.section-people > div', { yPercent: -30 }, { opacity: 1, yPercent: 0, stagger: 0.4 }, 'start');

            // Bubbles section
            tl.section.three
                .from('.more-likely-bubbles figure', 0.5, { opacity: 0, yPercent: 80, stagger: 0.2 }, 'start')
                .from('.more-likely-bubbles p', 0.5, { opacity: 0, y: -20, stagger: 0.1 }, 'start+=0.9');
        },

        efficacy() {
            tl.section.one   = gsap.timeline({ scrollTrigger: '#trigger_animation_one' }).addLabel('start', '+=0.5');
            tl.section.two   = gsap.timeline({ scrollTrigger: '#trigger_animation_two' }).addLabel('start', '+=0.5');
            tl.section.three = gsap.timeline({ scrollTrigger: '#trigger_animation_three' }).addLabel('start', '+=0.5');
            tl.section.four  = gsap.timeline({ scrollTrigger: '#trigger_animation_four' }).addLabel('start', '+=0.5');

            // Animation one items
            const aniGraph1  = qs('#ani-graph-1');
            const graphPaths = qsa('[data-name="bars"] path', aniGraph1);
            const graphText  = qsa('[data-name="digits"] text', aniGraph1);
            graphPaths.reverse();

            // Animation two items
            const aniGraph2 = qs('#ani-graph-2');
            const graph2Els = qsa('[data-name^="bars"]', aniGraph2);

            // Animation four items
            const titrationPhase2Svg = qs('#titration-phase-2-svg');
            const titrationLine2     = qs('[data-name="graph-line"]', titrationPhase2Svg);
            const titrationCircles2  = qsa('[data-name="balls"] circle', titrationPhase2Svg);
            const titrationText2     = qsa('[data-name="digits"] text', titrationPhase2Svg);

            // Create svg circle.
            const circle43 = $('.progress-ring-43').createSVGCircle({
                end:           43,
                strokeWidth:   25,
                circleRadius:  100,
                strokeBgColor: 'rgba(245, 139, 42, 0.2)',
                strokeColor:   gsap.getProperty(':root', '--secondary') || '#d61e34',
                title:         'Pie chart representing 43% of patients achieving zero seizures',
            }).find('[data-progress-ring]');

            // Section one
            tl.section.one
                .addLabel('bar')
                .from(graphPaths, { scaleY: 0, transformOrigin: 'bottom', stagger: 0.2 }, 'bars')
                .from(graphText, { y: 165, stagger: 0.2 }, 'bars')
                .counter(graphText, { end(i) { return this._targets[i].dataset.originalText; }, start: 0, digits: 1, stagger: 0.2 }, 'bars');

            // Section two
            graph2Els.forEach((el, i) => {
                const digits = qsa('text', el);
                const bars   = qsa('path', el);
                const label = `bar-${i}`;
                const offset = `start+=${i * 0.5}`;
                tl.section.two
                    .addLabel(label)
                    .from(bars, { scaleY: 0, transformOrigin: 'bottom', stagger: 0.2 }, offset)
                    .from(digits, { y: 340, stagger: 0.2 }, offset)
                    .counter(digits, { end(i) { return this._targets[i].dataset.originalText; }, start: 0, digits: 1, stagger: 0.2 }, offset);
            });

            // Section three.
            tl.section.three
                .from('#animation_3_img_1', { opacity: 0, scale: 0.5, yPercent: 50, duration: 0.6 }, 'start');

            gsap.set(titrationLine2, { attr: { 'stroke-dashoffset': 0, 'stroke-dasharray': '567 567' } });
            tl.section.four.from(titrationLine2, { attr: { 'stroke-dasharray': '0 567' }, duration: 1.5, ease: 'linear' }, 'start')
                .from(titrationCircles2, { scale: 0.5, transformOrigin: 'center center', ease: 'back', duration: 0.6, stagger: { amount: 1.5, from: 'start' } }, 'start')
                .from(titrationText2, { scale: 0.8, yPercent: 100, duration: 0.6, stagger: { amount: 1.5, from: 'end' } }, 'start')
                // .from('.titration-right-col .group', { opacity: 0, yPercent: -50, scale: 0.8, duration: 1, ease: 'back' }, 'start')
                .counter(circle43, { duration: 2, end: circle43.attr('data-offset'), start: circle43.attr('stroke-dashoffset'), attr: 'stroke-dashoffset' }, 'start')
                .counter(circle43.closest('.block-div').find('.progress-ring__counter'), { duration: 2, end: circle43.attr('data-end'), start: 0, digits: 1, suffix: '%' }, 'start');
        },

        faq() {
            // Open the first question on every section.
            qsa('.accordion.faq').forEach((el) => {
                $(qs('.faq__answer', el)).collapse('show');
            });

            // Temporary open all button.
            // const $openAllBtn = $('<button>', { class: 'btn btn-primary position-absolute', text: 'Open all' }).css({ top: '10px', right: '10px' });
            // $('.icon-row').first().append($openAllBtn);
            // $openAllBtn.on('click', () => {
            //     $('.faq__answer').addClass('show');
            //     $openAllBtn.remove();
            //     ScrollTrigger.refresh();
            // });
        },

        // mobileCollapse() {
        //     const mobileCollapse = qsa('.mobile-collapse');
        //     const isMobile = utils.getBreakpoint('xs sm');
        //     mobileCollapse.forEach((element) => {
        //         const id = element.getAttribute('id');
        //         // Trigger button is an element with the same class as the id.
        //         const trigger = qs(`.${id}`);
        //         if (isMobile) {
        //             // Set up the trigger.
        //             trigger.setAttribute('id', `${id}-trigger`);
        //             trigger.setAttribute('aria-controls', `#${id}`);
        //             trigger.setAttribute('aria-expanded', 'false');
        //             trigger.setAttribute('data-toggle', 'collapse');
        //             trigger.setAttribute('data-target', `#${id}`);
        //             trigger.classList.add('collapsed');
        //             trigger.classList.add('cursor-pointer');
        //             // Set up the collapse.
        //             element.classList.add('collapse');
        //             element.setAttribute('aria-labelledby', `${id}-trigger`);
        //         } else {
        //             trigger.classList.remove('collapsed');
        //             trigger.setAttribute('data-target', '');
        //             trigger.classList.remove('cursor-pointer');
        //             element.classList.remove('collapse');
        //         }
        //     });
        // },


        safety() {
            tl.section.one = gsap.timeline({ scrollTrigger: '#trigger_animation_one' }).addLabel('start', '+=0.5}');
            // tl.section.two = gsap.timeline({ scrollTrigger: '.trigger_animation_two' }).addLabel('start', '+=0.5}');

            // Section One animations.
            qsa('[data-name="digits"] text tspan').forEach((el, i) => {
                const end = el.textContent.replace('%', '');
                tl.section.one.counter(el, { start:      0,
                    end,
                    suffix:     '%',
                    wrapSuffix: false,
                    digits:     1,
                    duration:   end * 0.1 }, `start+=${i * 0.2}`);
            });

            // Section Two animations.
            // tl.section.two.from('svg.asm path', { opacity: 0, scale: 0.8, duration: 1, stagger: 0.1, transformOrigin: 'center center' }, 'start');
        },

        video() {
            const topVideos = new VideoCarousel({
                items:         qsa('.video-carousel-top > div'),
                dotsContainer: qs('.top-nav-dots'),
                arrowLeft:     qs('.top-arrow-left'),
                arrowRight:    qs('.top-arrow-right'),
            });

            topVideos.goTo(1, 0);

            const bottVideos = new VideoCarousel({
                items:         qsa('.video-carousel-bott > div'),
                dotsContainer: qs('.bott-nav-dots'),
                arrowLeft:     qs('.bott-arrow-left'),
                arrowRight:    qs('.bott-arrow-right'),
            });

            bottVideos.goTo(1, 0);
        },

        dosing() {
            tl.section.one =  gsap.timeline({ scrollTrigger: '#trigger_animation_one' }).addLabel('start', '+=1.5}');
            tl.section.two =  gsap.timeline({ scrollTrigger: '#getting-started_hash' }).addLabel('start', '+=1.5}');
            gsap.set('.pill-row > div', { opacity: 1 });
            tl.section.one.from('.pill-row > div', { opacity: 0, yPercent: -50, duration: 1, stagger: 0.3 }, 'start')
                .from('.pill-row figure', { opacity: 0, yPercent: -100, duration: 1, stagger: 0.3, ease: 'bounce' }, 'start+=.9');
            tl.section.two.from('.prescription-row figure', { opacity: 0, yPercent: 25, scale: 0.8, duration: 1, stagger: 0.3 }, 'start');
        },

        financialSupport() {
            tl.section.one = gsap.timeline({ scrollTrigger: '#financial_support_hash' }).addLabel('start'); // Bubbles

            // Bubbles section
            tl.section.one
                .fromTo('.bubbles-row figure', 0.5, { yPercent: 80 }, { opacity: 1, yPercent: 0, stagger: 0.2 }, 'start')
                .fromTo('.bubbles-row p', 0.5, { y: -20 }, { opacity: 1, y: 0, stagger: 0.1 }, 'start+=0.9');
        },

        downloadBtnHover() {
            const btnTl = gsap.timeline();
            const arrow = qs('path', this);
            const line  = qs('line', this);
            btnTl.addLabel('start')
                .fromTo(arrow, { yPercent: 0, opacity: 1 }, { yPercent: 200, opacity: 0, duration: 0.5, ease: 'ease-in' }, 'start')
                .to(line, { scaleX: 1.5, scaleY: 2, duration: 0.2, ease: 'ease-in', transformOrigin: 'center center' }, 'start+=0.1')
                .fromTo(arrow, { yPercent: -200, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.5, ease: 'ease-out' }, 'start+=0.5')
                .to(line, { scaleX: 1, scaleY: 1, duration: 0.2, ease: 'ease-in' }, 'start+=0.6');
        },

        arrowBtnHover(e) {
            const btnTl = gsap.timeline();
            const arrow  = qs('g', this);
            const circle = qs('circle', this);
            if (e.type === 'mouseenter') {
                btnTl.addLabel('start')
                    .fromTo(arrow, { x: 0 }, { x: 4, duration: 0.3 }, 'start')
                    .fromTo(circle, { 'stroke-dashoffset': 95 }, { 'stroke-dashoffset': 0, duration: 0.3 }, 'start')
                    .fromTo(circle, { opacity: 1 }, { opacity: 0, duration: 0.3 }, 'start+=0.3')
                    .addLabel('end')
                    .to(circle, { 'stroke-dashoffset': 95, duration: 0 }, 'end')
                    .to(circle, { opacity: 1, duration: 0 }, 'end');
            } else {
                btnTl.to(arrow, { x: 0, duration: 0.3 });
            }
        },

        /**
         * Move site map items to the correct place.
         */
        moveSiteMap() {
            if ($('#site-map').length)
                $('[data-title="masterclass"], [data-title="app-education"]').insertAfter('[data-title="contact-a-rep"]');
        },

        addYoutubeAPI() {
            if (!app.$youTubeVideos.length) return;
            // create youtube api script tag
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.querySelector('script');
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        },

        /**
         * Initiate app.
         */
        init() {
            app.$modals.on('show.bs.modal hidden.bs.modal', app.onModalsShowAndHidden);
            app.updateNumbers();
            app.moveSiteMap();
            app.setElementsHeight();
            app.triggerAreYouHCP();
            app.scrollTo(window.location.hash, 500);
            app.globalAnimations();
            app.addYoutubeAPI();
            app.openModalFromURL();
            // app.mobileCollapse();

            $('.collapse').on('shown.bs.collapse hidden.bs.collapse', ScrollTrigger.refresh);

            // Select all links with hashes
            app.$hashAnchors.on('click', app.moveToHash);

            $(app.leaveModalBtnSelector).on('click', app.leaveModalBtn);
            // Fires again if there is a form present in the dom.
            utils.globals.$document.on('nfFormReady', () => {
                $(app.leaveModalBtnSelector).on('click', app.leaveModalBtn);
                ScrollTrigger.refresh(); // Refresh scroll trigger because form comes in late.
            });

            app.$mainMenu.on('shown.bs.collapse hidden.bs.collapse', (e) => {
                const shown = e.type === 'shown';
                shown ? tl.hamburgerMenu.play() : tl.hamburgerMenu.reverse();
            });

            app.$mainMenu.on('show.bs.collapse hide.bs.collapse', (e) => {
                const show = e.type === 'show';
                utils.globals.$body.toggleClass('menu-opened', show);
                if (show) {
                    const $active = app.$mainMenu.find('.current_page_parent .dropdown-menu');
                    const $allMenus = app.$mainMenu.find('.dropdown');
                    toggleDropdown($allMenus.get(), 'hide');
                    $active.dropdown('toggle');
                    utils.globals.$body.addClass('menu-opened');
                }
            });

            app.$closeISIBtn.on('click', () => {
                tl.closeISITween.to(window, {
                    duration: 0,
                    scrollTo: {
                        y: app.onISIOpenLocation,
                    },
                });
                app.updateISITrey('close');
            });

            // Window scroll/Resize
            utils.globals.$window.on('scroll', app.onWindowScroll);
            utils.globals.$window.on('resize', app.onWindowResize);

            // Clear Storage.
            app.$clearStorage.click(app.clearStorage);

            // Load each section depending on body class.
            if (utils.globals.$body.hasClass('epilepsy-facts'))
                app.epilepsyFacts();
            else if (utils.globals.$body.hasClass('efficacy'))
                app.efficacy();
            else if (utils.globals.$body.hasClass('safety'))
                app.safety();
            else if (utils.globals.$body.hasClass('dosing-administration'))
                app.dosing();
            else if (utils.globals.$body.hasClass('faq'))
                app.faq();
            else if (utils.globals.$body.hasClass('video'))
                app.video();
            else if (utils.globals.$body.hasClass('financial-support'))
                app.financialSupport();


            ScrollTrigger.matchMedia({
                // desktop
                '(min-width: 768px)': function () {
                    app.$downloadBtns.on('mouseenter', app.downloadBtnHover);
                    app.$arrowBtns.on('mouseenter mouseleave', app.arrowBtnHover);
                },

                // mobile
                '(max-width: 767.98px)': () => {
                    // Bring all the sections to the end of the animation on mobile.
                    _.each(tl.section, tween => tween.seek('-=0', false));
                },
            });

            // FAQ
            $('.faq__answer, .mobile-collapse').on('shown.bs.collapse hidden.bs.collapse', app.collapseOnShownHidden);
            $('.faq__answer-container').each((i, el) => {
                const links = [...el.querySelectorAll('a')];
                const question = el.dataset.question;
                links.forEach((link) => {
                    const label = link.dataset.label || link.textContent;
                    link.setAttribute('data-label', `${label} CTA - ${question}`);
                });
            });
            // Add modal data attribute to menu links.
            $('.nav-full-button.orange a').attr('data-modal', '#leave-modal-app');
            $('.nav-full-button.purple a').attr('data-modal', '#leave-modal-university');

            // Add category to menu items
            $('.cat-download, .cat-download a').attr('data-category', 'Download');
            $('.cat-footer, .cat-footer a').attr('data-category', 'Footer');
            $('.is-provider-youtube iframe').attr('enablejsapi', true);

            app.$body.on('click', 'a, button', function f(e) {
                const $this      = $(this);
                const ariaLabel  = $this.attr('aria-label') || false;
                const ariaHidden = $this.attr('aria-hidden') || false;
                const dataLabel  = $this.data('label') || false;

                if (ariaLabel === 'Close' && !dataLabel) return; // Don't track the close button.
                if (ariaHidden === 'true') return; // Don't track hidden elements.

                const params    = {};
                const url       = $this.attr('href') || '';
                const labelPrefix = $this.data('label-prefix') || false;
                params.label    = $this.data('label') || $this.text() || ariaLabel || $this.attr('title');
                params.category = '';

                if (url)
                    params.url = url;

                // Header links
                if (
                    $this.hasClass('ot-floating-button__close') // Cookie button
                    || $this.hasClass('ot-pc-refuse-all-handler') // Refuse All
                    || $this.hasClass('save-preference-btn-handler') // Confirm Choices
                    || $this.attr('id') === 'accept-recommended-btn-handler' // Allow All
                    // || url.includes('privacy-policy') // Privacy Policy
                )
                    params.category = 'Header';

                // All else
                else if ($this.data('category'))
                    params.category = $this.data('category');
                else if (url.includes('http') && !url.includes(window.location.hostname))
                    params.category = 'External Link';
                else if (url.includes('mailto:'))
                    params.category = 'Contact Click';

                // Cookie button
                if ($this.hasClass('ot-floating-button__close'))
                    params.label = 'Your Privacy Choices';

                if (labelPrefix)
                    params.label = `${labelPrefix} - ${params.label}`;

                if (!params.category)
                    params.category = 'CTA';

                trackEvent('link_click', params);
            });

            // Checkboxes for cookie consent.
            // May need to get more granular with the selector if there are ever other checkboxes on the site.
            app.$body.on('change', 'input[type=checkbox]', function f() {
                const label    = $(this).parent().find('.ot-label-txt').text();
                const category = 'Header';
                trackEvent('checkbox_change', { label: `Toggle - ${label}`, category, value: this.checked });
            });
        },
    };


    // Document ready.
    $(app.init);
}(jQuery, window.utilities, document));
